import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-content-center",
  style: {"width":"100%"}
}
const _hoisted_2 = ["src"]

import Api from "@/services/api"
    import { Category } from "@/services/types"
    import { ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref } from "vue"
    import { useStore } from "vuex"

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateCategory',
  setup(__props) {

    const store = useStore()
    const category = reactive<Category>({
        name: '',
    })

    const rules = reactive<FormRules<Category>>({
        name: [{required: true, message: 'Insira o nome da categori', min: 1}],
        image: [{required: false, message: 'Selecione a imagem'}]
    })

    const image = ref()
    const uri = ref<string>()
    const imageFile = ref<File | Blob>()
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const selectImage = () => {
        imageFile.value = image.value?.input.files[0]
        uri.value = URL.createObjectURL(imageFile.value as File)
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const form = new FormData()
                if (category.name) {
                    form.append("name", category.name)
                }
                if (imageFile.value) {
                    form.append("image", imageFile.value)
                }
                const res = await Api.post('admin/categories', category, form)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Categoria criada com sucesso'})
                    store.commit('setOpenModal', -1)
                    // router.push('/categories')
                    // location.reload()
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "formRef",
    ref: formRef,
    disabled: saving.value,
    rules: rules,
    model: category,
    "label-position": "top"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (uri.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: uri.value,
              style: {"max-width":"140px"}
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_form_item, {
        prop: "name",
        label: "Nome da categoria"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            name: "name",
            modelValue: category.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((category.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        prop: "image",
        label: "Selecione uma imagem"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "file",
            ref_key: "image",
            ref: image,
            name: "image",
            onChange: selectImage
          }, null, 512)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        plain: "",
        loading: saving.value,
        size: "large",
        type: "primary",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (submit(formRef.value)), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Cadastrar ", -1)
        ]))]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["disabled", "rules", "model"]))
}
}

})